import { withStyles } from '@material-ui/core/styles';
import ClientsListItem from './ClientsListItem';
import styles from './ClientsListItem.styles';

export default withStyles(styles)(ClientsListItem);
